// Scripts injected via DOMParser are inert — re-create them so they execute.
const activateScripts = (container: Element): void => {
  container.querySelectorAll("script").forEach((oldScript) => {
    const newScript = document.createElement("script");
    Array.from(oldScript.attributes).forEach((attr) => {
      newScript.setAttribute(attr.name, attr.value);
    });
    newScript.textContent = oldScript.textContent;
    oldScript.parentNode!.replaceChild(newScript, oldScript);
  });
};

type FragmentInjection = {
  fetchSelector: string;
  currentSelector: string;
};

export const injectFragments = (
  url: string,
  fragments: FragmentInjection[],
): Promise<void> => {
  const headers: RequestInit["headers"] = {};

  if (import.meta.env.VITE_HF_USER && import.meta.env.VITE_HF_PASS) {
    headers.Authorization =
      "Basic " +
      btoa(`${import.meta.env.VITE_HF_USER}:${import.meta.env.VITE_HF_PASS}`);
  }

  return fetch(url, { headers })
    .then((r) => {
      if (!r.ok) {
        throw new Error(`Failed to fetch fragments from ${url}: ${r.status}`);
      }

      return r.text();
    })
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, "text/html");

      fragments.forEach(({ fetchSelector, currentSelector }) => {
        const fetched = doc.querySelector(fetchSelector);
        const current = document.querySelector(currentSelector);

        if (fetched && current) {
          current.replaceWith(fetched);
          activateScripts(fetched);
        }
      });
    })
    .catch((error) => {
      console.error("Failed to inject fragments", error);
    });
};
